import React, { useState, useEffect } from "react";
import { Modal, Input, Button, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import ENVIRONMENT from "../../../../environments";
import "./GenerateAiVideoModal.scss";
import SubscriptionUpgradeManager from "../SubscriptionUpgradeManager/SubscriptionUpgradeManager";
const { TextArea } = Input;

const GenerateAiVideoModal = ({ visible, onCancel, imageUrl, image_id, onSuccess = () => {} }) => {
    const [prompt, setPrompt] = useState("");
    const [generateVideoLoader, setGenerateVideoLoader] = useState(false);
    const [requestStatus, setRequestStatus] = useState('update_subscription');
    const [subscriptionUpgradeManagerModel, setSubscriptionUpgradeManagerModel] = useState(false);
    const [cardStatus, setCardStatus] = useState(0);

    // Call API every time modal opens
    useEffect(() => {
        if (visible) {
            loadUserRequestStatus();
        }
        
        // Reset prompt when modal closes
        if (!visible) {
            setPrompt("");
        }
    }, [visible]);

    const loadUserRequestStatus = () => {
        let payload = {
            "username": localStorage.getItem('username'),
            "request_type": "ai_video",
            "action": "check",
            "category": ""
        }
        axios.post(ENVIRONMENT.PAYMENT_GATEWAY, payload).then(res => {
            console.log('Video request status:', res.data)
            setRequestStatus(res.data['request_allowed']);
            setSubscriptionUpgradeManagerModel(res.data['subscription_upgrade_model']);
            setCardStatus(res.data['card_status']);
        });
    };


    const handleGenerate = () => {
        setGenerateVideoLoader(true);

        if(requestStatus == 'update_subscription') {
            setSubscriptionUpgradeManagerModel(true);
            setGenerateVideoLoader(false);
            return;
        }

        let request_payload = {
            action: 'trigger_video_generation_job',
            image_id: image_id,
            prompt_text: prompt,
            username: localStorage.getItem('username'),
        }
        if(localStorage.getItem('company_id')) {
            request_payload.company_id = localStorage.getItem('company_id');
        }

        let gateway_payload = {
            "username": localStorage.getItem('username'),
            "request_type": "ai_video",
            "action": "perform",
            "request_payload": request_payload,
            "category": "",
            "request_id": Date.now().toString()
        }
        axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload).then(async (res) => {
            console.log(res);
            if(res.data.status == 1 && res.data.action_response.status == 200) {
                try {
                    await onSuccess();
                } catch (error) {
                    console.error("Error in onSuccess callback:", error);
                }
                setGenerateVideoLoader(false);
                onCancel();
                message.success('Video generation request submitted successfully');
            } else {
                setGenerateVideoLoader(false);
                message.error('Failed to submit video generation request');
            }
        });
    };

    return (
        <>  
        <Modal
            visible={visible}
            onCancel={onCancel}
            className="generate-ai-video-modal"
            centered
            width={600}
            footer={null}
        >
            <div style={{marginTop: 20}}>
                <span className="manrope f-20 black-00 w-500">Generate Video</span>
                <div className="modal-content">
                    <img src={imageUrl} alt="Source" className="img-for-video" />
                    <TextArea
                        placeholder="Describe your video for this image..."
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        autoSize={{ minRows: 4, maxRows: 6 }}
                        className="prompt-textarea"
                    />
                </div>
                <div style={{display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 10}}>
                    <Button key="cancel" onClick={onCancel} className="modal-okay-gray square font-14">
                        Cancel
                    </Button>
                    <Button
                        key="generate"
                        type="primary"
                        onClick={handleGenerate}
                        className="generate-ai-btn font-14"
                        disabled={!prompt.trim() || generateVideoLoader}
                    >
                        {generateVideoLoader ? <LoadingOutlined /> : <img
                            src="/img/ai_creator/ai-twinkle.svg"
                            style={{ width: "20px", height: "20px", marginRight: "8px" }}
                        />}
                        Generate — 45 credits
                    </Button>
                </div>
            </div>
        </Modal>
        <SubscriptionUpgradeManager
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
            cardStatus={cardStatus}
            loadUserRequestStatus={loadUserRequestStatus}
            requestType={'ai_video'}
        />
        </>
    );
};

export default GenerateAiVideoModal;
